// src/components/PageHero.js
import React from "react";
import "./PageHero.css";

const PageHero = ({ label, heading, sub }) => (
  <section className="page-hero">
    <div className="page-hero__orb" aria-hidden="true" />
    <div className="container page-hero__content">
      {label && <p className="section-label">{label}</p>}
      <h1 className="page-hero__title">{heading}</h1>
      {sub && <p className="page-hero__sub">{sub}</p>}
    </div>
  </section>
);

export default PageHero;
